namespace advisorop.components.common {

    export class ApplicationTrackerController {

        user: domains.IUser;
        apptrackerdata: domains.IAppTrackerData[];
        onAccountArchived: (args: { accountId: number }) => void;
        showProposedAmount: boolean = false;
        activityTypes: domains.ILOV[];
        // These are 0-based
        firstActivityColumnIndex: number = 6;
        lastActivityColumnIndex: number = 15;
        lastActivityFieldIndex: number = 9;
        isAdvisorUser: boolean = false;
        isServicerUser: boolean = false;

        activitiesCounts: { [key: string]: number } = {};
        activityColumnHeadersPrefix: { [key: string]: string } = {}

        accountStatusOpen = domains.AccountStatus.OPEN;

        dg: DevExpress.ui.dxDataGridOptions = {
            export: {
                enabled: true,
                fileName: "ApplicationTracker"
            },
            bindingOptions: {
                dataSource: "vm.apptrackerdata"
            },
            scrolling: {
                mode: "standard",
                useNative: true
            },
            height: "500px",
            paging: { pageSize: 100 },
            rowAlternationEnabled: false,
            showBorders: true,
            showColumnLines: true,
            showRowLines: true,
            columnAutoWidth: true,
            allowColumnReordering: false,
            allowColumnResizing: true,
            columnChooser: {
                enabled: false,
                title: "Select columns"
            },
            wordWrapEnabled: true,
            filterRow: { visible: true },
            headerFilter: { visible: false },
            searchPanel: {
                visible: false,
                width: 240,
                placeholder: "Search..."
            },
            editing: {
                allowUpdating: true,
                allowDeleting: false,
                allowAdding: false,
                mode: "cell"
            },
            columns: [
                { dataField: "advisorName", caption: "Advisor", cellTemplate: "advAction", allowEditing: false, width: 70 },
                { dataField: "householdName", caption: "Household", allowEditing: false, width: 70 },
                { dataField: "accountNumber", caption: "Acct. Number", allowEditing: false, width: 70 },
                { dataField: "accountName", caption: "Acct. Name", allowEditing: false, width: 70 },
                { dataField: "productDescription", caption: "Product Desc.", allowEditing: false, width: 70 },
                { dataField: "proposedAmount", caption: "Proposed Amount", allowEditing: false, width: 70, visible: this.showProposedAmount, format: "currency" },
                // field = 'act_' + ActivityID
                {
                    dataField: "activities[0].endDate",
                    caption: "1. Initiate proposal",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    allowEditing: false,
                    name: "" + domains.AccActivtyId.INITIATE_PROPOSAL + "",
                },
                {
                    dataField: "activities[1].endDate",
                    caption: "2. Prep. & Send app",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.APP_PREPARE_SEND + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[2].endDate",
                    caption: "3. Receive, Review & Submit app",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.APP_RECEIVE_SUBMIT + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[3].endDate",
                    caption: "4. Track & Confirm acct. open",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.ACCT_OPEN + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[4].endDate",
                    caption: "5. Link acct.",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.ACCT_LINKED + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[5].endDate",
                    caption: "6. Confirm acct. funded",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.ACCT_FUNDED + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[6].endDate",
                    caption: "7. Invest acct.",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.ACCT_INVESTED + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[7].endDate",
                    caption: "8. Setup acct. billing",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    name: "" + domains.AccActivtyId.ACCT_BILLING_SETUP + "",
                    allowEditing: false
                },
                {
                    dataField: "activities[8].endDate",
                    caption: "9. Follow-up with advisor & client",
                    dataType: "date",
                    width: 90,
                    cellTemplate: "tmpAction20",
                    allowEditing: false,
                    name: "" + domains.AccActivtyId.FOLLOWUP_ADVISOR_CLIENT + "",
                    visible: false,
                },
                {
                    dataField: "activities[0].notes",
                    caption: "Notes",
                    width: 300,
                    allowEditing: false
                },
                //{
                //    dataField: "activities[9].endDate",
                //    caption: "10. Archive",
                //    dataType: "date",
                //    width: 60,
                //    cellTemplate: "tmpAction20"
                //},
                { dataField: "id", caption: "#", cellTemplate: "btnActions", width: 130, allowEditing: false, visible: false }
            ],
            onRowUpdating: (e) => this.onUpdate(e),
            onRowUpdated: (e) => this.onUpdate(e),
            onEditingStart: (e) => this.onEditingStart(e),
            onCellPrepared: (e) => this.onCellPrepared(e),
            onContentReady: (e) => this.onContentReady(e),
            onInitialized: (e) => this.onDataGridInitialized(e),
        };
        activityDG: DevExpress.ui.dxDataGrid;

        static $inject = ["appTrackerApi", "generalService", "identityService", "advisorDashboardService", "$filter"]
        constructor(
            private apt: services.AppTrackerApi,
            private gs: services.GeneralService,
            private ids: services.IdentityService,
            private ads: services.AdvisorDashboardService,
            private filter: any) {

            this.activityColumnHeadersPrefix[domains.AccActivtyId.INITIATE_PROPOSAL] = "1. Initiate proposal";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.APP_PREPARE_SEND] = "2. Prep. & Send app";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.APP_RECEIVE_SUBMIT] = "3. Receive, Review & Submit app";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.ACCT_OPEN] = "4. Track & Confirm acct. open";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.ACCT_LINKED] = "5. Link acct.";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.ACCT_FUNDED] = "6. Confirm acct. funded";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.ACCT_INVESTED] = "7. Invest acct.";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.ACCT_BILLING_SETUP] = "8. Setup acct. billing";
            this.activityColumnHeadersPrefix[domains.AccActivtyId.FOLLOWUP_ADVISOR_CLIENT] = "9. Follow-up with advisor & client";
        }

        // Magic 5 represent index of the first column with Activity Field
        //getFieldIndex = (columnIndex: number): number => columnIndex - this.firstActivityColumnIndex;
        getFieldIndex(columnIndex: number): number {
            //console.log("GET FIELD INDEX ---- COL INDEX", columnIndex);
            //console.log("GET FIELD INDEX ---- FIRST ACTIVITY INDEX", this.firstActivityColumnIndex);
            return columnIndex - this.firstActivityColumnIndex;
        }

        getFieldActivity = (e: any): domains.AccountLifeCycleViewModel => {
            const fldInd = this.getFieldIndex(e.column.index);
            //console.log("fldInd ==== ", fldInd);
            if (fldInd >= 0) {
                //const colIndex = this.getFieldIndex(e.column.index);
                if (fldInd < this.lastActivityFieldIndex) {
                    const act = e.data.activities[fldInd] as domains.AccountLifeCycleViewModel;
                    act.fieldIndex = fldInd;
                    return act;
                } else if (fldInd == this.lastActivityFieldIndex) {
                    // Each activity can have notes, but in this implementation, notes are associated wtih the first activity.
                    const act = e.data.activities[0] as domains.AccountLifeCycleViewModel;
                    act.fieldIndex = fldInd;
                    return act;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, item: any) => {
            if (item.data.accountNumber) {
                this.ads.calculateBackOfficeParamsAsync(level, item.data.accountId).then(params => {
                    this.ads.openBackOfficeReport(report, params);
                });
            } else {
                toastr.warning("This account has no account number");
            }
        }

        onUpdate = (e: any) => {
            // component, element, model, oldData, newData, key, 
            //console.log("Updating data...", e);

            const lifeCycleViewModel = {} as domains.AccountLifeCycleViewModel;

            lifeCycleViewModel.id = e.oldData.activities[0].id;
            lifeCycleViewModel.notes = e.newData["activities[0]"].notes;
            //console.log("NOTES ARE...", lifeCycleViewModel.notes);

            e.oldData.activities[0].notes = lifeCycleViewModel.notes;

            this.apt.updateNotes(lifeCycleViewModel).then(response => {
                let dg = DevExpress.ui.dxDataGrid.getInstance($('#dgChartAppTracker')) as DevExpress.ui.dxDataGrid;
                if (dg) {
                    dg.refresh();
                }
                toastr.success("Notes updated.");
            }, err => this.gs.showError(err));
        }

        onEditingStart = (e: any) => {
            // direct edit has been forbiden
            //console.log("In Editing Start...", e);
            //e.cancel = true;
        }

        onCellPrepared = (e: any) => {
            // console.log("OnCellPrepared Start", e);
            if (e.rowType === "header" && e.column.index >= this.firstActivityColumnIndex && e.column.index < this.lastActivityColumnIndex) {
                //console.log("header....");
                e.cellElement.addClass("top-header");
            }
            else if (e.rowType === "data") {
                const activity = this.getFieldActivity(e);

                if (activity) {
                    let bgColorClass = "bg-danger";
                    if (activity.fieldIndex < this.lastActivityFieldIndex) {
                        //console.log("ACT FieldIndex --A:", activity.fieldIndex);
                        //console.log("last Activity --A:", this.lastActivityFieldIndex);
                        switch (activity.activityStatus) {
                            case domains.LifeCycleActivityStatus.CLAIMED:
                                bgColorClass = "bg-warning";
                                break;
                            case domains.LifeCycleActivityStatus.COMPLETED:
                                bgColorClass = "bg-success";
                                break;
                            case domains.LifeCycleActivityStatus.SKIPPED:
                                bgColorClass = "bg-light-gray";
                                break;
                            default:
                                bgColorClass = "bg-danger";
                        }
                    } else {
                        //console.log("ACT FieldIndex --B:", activity.fieldIndex);
                        //console.log("last Activity --B:", this.lastActivityFieldIndex);
                        bgColorClass = "bg-info";
                    }

                    e.cellElement.removeClass().addClass(bgColorClass);
                    e.cellElement.addClass("advisorop-gridcol");
                }
            }
        }

        onContentReady = (e: any) => {
            // Notes column - allow servicer to edit
            e.component.columnOption("Notes", "allowEditing", this.isServicerUser);
            e.component.columnOption("Proposed Amount", "visible", this.showProposedAmount);
        }

        onDataGridInitialized = (e) => {
            this.activityDG = e.component;
        }

        updateActivitiesCaptions(): void {
            if (this.apptrackerdata != undefined && this.activityDG != undefined) {
                this.countClaimedActivities();
                var values = Object.values(domains.AccActivtyId);
                values = values.slice(values.length / 2);
                values.forEach(value => {
                    //let value = domains.AccActivtyId[key];
                    let count = this.activitiesCounts[value];
                    let caption = `${this.activityColumnHeadersPrefix[value]} (${count})`; 
                    this.activityDG.columnOption(`${value}`, "caption", caption)
                })
            }
        }

        // An account leaves the App Tracker as soon as its workflow is finished, so drop the
        // row on the spot rather than leaving a finished account sitting in the grid until
        // someone reloads the page.
        dropRowIfFinished = (row: domains.IAppTrackerData, updated: domains.AccountLifeCycleViewModel): boolean => {
            if (!updated || !updated.accountArchived) {
                return false;
            }

            const ind = this.apptrackerdata.indexOf(row);
            if (ind >= 0) {
                this.apptrackerdata.splice(ind, 1);
            }

            // the parent holds the unfiltered list, so it has to forget the account too -
            // otherwise it comes back the moment a filter is toggled
            if (this.onAccountArchived) {
                this.onAccountArchived({ accountId: row.accountId });
            }

            if (this.activityDG) {
                this.activityDG.refresh();
            }

            this.updateActivitiesCaptions();

            return true;
        }

        // Completing one step can close the steps that go with it. Fold those into the row so
        // the grid shows them without waiting for a refresh.
        applyAlsoUpdated = (row: domains.IAppTrackerData, updated: domains.AccountLifeCycleViewModel): void => {
            if (!updated || !updated.alsoUpdated || updated.alsoUpdated.length === 0) {
                return;
            }

            updated.alsoUpdated.forEach(closed => {
                const ind = row.activities.findIndex(a => a.id === closed.id);
                if (ind >= 0) {
                    row.activities[ind] = closed;
                }
            });

            if (this.activityDG) {
                this.activityDG.refresh();
            }
        }

        onClaimTask = (itm: any) => {

            // console.log("Claim task", itm);

            if ((!this.isAutoCompleteActivity(itm)) || (confirm("Claiming an automated task... Are you sure ?"))) {
                const fldInd = this.getFieldIndex(itm.column.index);

                const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

                this.apt.claimActivity(activity.id).then(response => {
                    itm.data.activities[fldInd] = response.data;
                    itm.cellElement.removeClass().addClass("bg-warning");
                    itm.cellElement.addClass("advisorop-gridcol");
                    this.updateActivitiesCaptions();
                }, err => this.gs.showError(err));
            }
        }

        onStealTask = (itm: any) => {

            // console.log("Steal task", itm);

            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            this.apt.stealActivity(activity.id).then(response => {
                itm.data.activities[fldInd] = response.data;
                itm.cellElement.removeClass().addClass("bg-warning");
                itm.cellElement.addClass("advisorop-gridcol");
            }, err => this.gs.showError(err));
        }

        onUnClaimTask = (itm: any) => {
            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            this.apt.unClaimActivity(activity.id).then(response => {
                itm.data.activities[fldInd] = response.data;
                itm.cellElement.removeClass().addClass("bg-danger");
                itm.cellElement.addClass("advisorop-gridcol");
                this.updateActivitiesCaptions();
            }, err => this.gs.showError(err));
        }

        onCompleteTask = (itm: any) => {
            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            this.apt.completeActivity(activity.id).then(response => {
                itm.data.activities[fldInd] = response.data;

                if (this.dropRowIfFinished(itm.data, response.data)) {
                    return;
                }

                itm.cellElement.removeClass().addClass("bg-success");
                itm.cellElement.addClass("advisorop-gridcol");
                this.applyAlsoUpdated(itm.data, response.data);
                this.updateActivitiesCaptions();
            }, err => this.gs.showError(err));
        }

        onUndoTask = (itm: any) => {
            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            this.apt.undoActivity(activity.id).then(response => {
                itm.data.activities[fldInd] = response.data;
                itm.cellElement.removeClass().addClass("bg-warning");
                this.updateActivitiesCaptions();
            }, err => this.gs.showError(err));
        }

        onSkipTask = (itm: any) => {
            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            this.apt.skipActivity(activity.id).then(response => {
                itm.data.activities[fldInd] = response.data;

                if (this.dropRowIfFinished(itm.data, response.data)) {
                    return;
                }

                itm.cellElement.removeClass().addClass("bg-light-gray");
                itm.cellElement.addClass("advisorop-gridcol");
                this.updateActivitiesCaptions();
            }, err => this.gs.showError(err));
        }

        onImpersonateActivity = (itm: any) => {
            // console.log(`Impersonating advisor...`);

            const fldInd = this.getFieldIndex(itm.column.index);

            const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

            if (!itm.data.advisorUsername) {
                this.gs.showError(`Missing Advisor's username`);
                return;
            }

            if (window.confirm(`Impersonate ${itm.data.advisorName} ?`)) {
                // authenticate servicer as advisor 
                this.ids.impersonateUser(itm.data.advisorUsername)
                    .then(response => {
                        // clear localstorage
                        localStorage.clear();
                        // redirect page to advisor dashboard if account is not open go into new account opening,
                        // if open, go to account summary
                        if (itm.row.data.accountStatus < this.accountStatusOpen)
                            window.location.href = `/advisor/newupdateaccount/${itm.data.accountId}`;
                        else
                            window.location.href = `/advisor/accountsummary/${itm.data.accountId}`;
                    }).catch(err => toastr.error(`Error ${err.status} ${err.data}`))
            }
        }

        showClaimButton = (itm: any) => {
            if (this.isAdvisorUser)
                return false;

            const activity = this.getFieldActivity(itm);

            if (!activity) {
                return false;
            }

            var okToShow: boolean = true;
            const myStatus = activity.activityStatus === domains.LifeCycleActivityStatus.UNCLAIMED;

            if (activity.fieldIndex > 0) {
                // all previous activities completed or skipped
                var ind: number = activity.fieldIndex - 1
                while (ind >= 0 && !activity.canClaim) {
                    if (!(itm.data.activities[ind].activityStatus === domains.LifeCycleActivityStatus.COMPLETED
                        || itm.data.activities[ind].activityStatus === domains.LifeCycleActivityStatus.SKIPPED)) {
                        okToShow = false;
                        break;
                    }
                    ind = ind - 1;
                }
                return (myStatus && okToShow);
                //&& (itm.data.activities[activity.fieldIndex - 1].activityStatus === domains.AccActivityStatus.COMPLETED
                //    || itm.data.activities[activity.fieldIndex - 1].activityStatus === domains.AccActivityStatus.SKIPPED);
            } else {
                return myStatus;
            }
        }

        isAutoCompleteActivity = (itm: any, logact = 0) => {
            const activity = this.getFieldActivity(itm);

            //if (activity.fieldIndex === 3 ) {
            // console.log('Autocomplete activity', activity);
            //}

            if (!activity) {
                return false;
            }

            const l = this.activityTypes.filter(f => f.value === activity.activityId)[0];

            //if (activity.fieldIndex === 3) {
            // console.log('Autocomplete activity lov', l);
            //}

            return l && l.extra3 === "auto";
        }

        isClaimedByMe = (itm: any) => {
            //console.log("ITEM IS:", itm);
            //const fldInd = this.getFieldIndex(itm.columnIndex);
            const fldInd = this.getFieldIndex(itm.column.index);

            if (fldInd >= 0) {
                const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

                return activity.activityStatus ===
                    domains.LifeCycleActivityStatus.CLAIMED && activity.responsibleUserId === this.user.id;
            }

            return false;
        }

        canUndo = (itm: any) => {
            if (this.isAdvisorUser)
                return false;

            //const fldInd = this.getFieldIndex(itm.columnIndex);
            const fldInd = this.getFieldIndex(itm.column.index);

            if (fldInd >= 0) {
                const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

                if (fldInd == this.lastActivityFieldIndex) { // last activity
                    return (activity.activityStatus === domains.LifeCycleActivityStatus.COMPLETED);
                } else if (fldInd >= 0 && fldInd < this.lastActivityFieldIndex) { // is activity and not last
                    var i: number = 1;
                    var nextAct = itm.data.activities[fldInd + i] as domains.AccountLifeCycleViewModel;
                    while (fldInd + i < this.lastActivityFieldIndex && nextAct.activityStatus === domains.LifeCycleActivityStatus.SKIPPED) {
                        i = i + 1;
                        nextAct = itm.data.activities[fldInd + i] as domains.AccountLifeCycleViewModel;
                    }
                    return activity.activityStatus === domains.LifeCycleActivityStatus.COMPLETED && nextAct.activityStatus === domains.LifeCycleActivityStatus.UNCLAIMED;
                }
            }

            return false;
        }

        showImpersonateButton = (itm: any) => {
            if (this.isAdvisorUser)
                return false;

            //const fldInd = this.getFieldIndex(itm.columnIndex);
            const fldInd = this.getFieldIndex(itm.column.index);

            // Up to and including Link Acct
            return fldInd <= 4 && this.isClaimedByMe(itm);
        }

        showPPHoldingsButton = (itm: any) => {
            //const fldInd = this.getFieldIndex(itm.columnIndex);
            const fldInd = this.getFieldIndex(itm.column.index);

            // Funded / Invested
            return (fldInd == 5 || fldInd == 6) && this.isClaimedByMe(itm);
        }

        getActivityStatusText = (itm: any) => {

            //const fldInd = this.getFieldIndex(itm.columnIndex);
            const fldInd = this.getFieldIndex(itm.column.index);

            if (fldInd >= 0) {

                const activity = itm.data.activities[fldInd] as domains.AccountLifeCycleViewModel;

                //console.log(`Getting activity text for ind:${fldInd} act: ${activity.id} stat: ${activity.activityStatus} date: ${itm.value}`);
                if (activity.activityStatus === domains.LifeCycleActivityStatus.CLAIMED) {
                    return `${this.filter("date")(activity.startDate, "shortDate")}<br /><strong>${activity.responsibleUserName}</strong>`;
                } else if (activity.activityStatus === domains.LifeCycleActivityStatus.COMPLETED) {
                    return `${this.filter("date")(itm.value, "shortDate")}<br /><strong>Done<br />${activity.responsibleUserName}</strong>`;
                } else if (activity.activityStatus === domains.LifeCycleActivityStatus.SKIPPED) {
                    //console.log("Skipped activity....");
                    return `${this.filter("date")(activity.dateCreated, "shortDate")}<br /><strong>Skip</strong>`;
                }
            } else {
                return "";
            }
        }

        countClaimedActivities(): void {
            this.activitiesCounts = {};

            if (!this.apptrackerdata || this.apptrackerdata.length === 0) {
                return;
            }

            let indexOfBillingStep = this.apptrackerdata[0].activities.findIndex(a => a.activityId == domains.AccActivtyId.ACCT_BILLING_SETUP);
            this.activitiesCounts = this.apptrackerdata.reduce((acc, account) => {
                for (let i = 0; i < account.activities.length; i++)
                {
                    let a = account.activities[i];
                    if (acc[a.activityId] == undefined) {
                        acc[a.activityId] = 0;
                    }
                    if (a.activityStatus == domains.LifeCycleActivityStatus.CLAIMED || a.activityStatus == domains.LifeCycleActivityStatus.UNCLAIMED) {
                        acc[a.activityId] += 1;
                        if (a.activityId != domains.AccActivtyId.ACCT_BILLING_SETUP) {
                            let billingActivty = account.activities[indexOfBillingStep]
                            if (acc[domains.AccActivtyId.ACCT_BILLING_SETUP] == undefined) {
                                acc[domains.AccActivtyId.ACCT_BILLING_SETUP] = 0;
                            }
                            acc[domains.AccActivtyId.ACCT_BILLING_SETUP] += (billingActivty.activityStatus == domains.LifeCycleActivityStatus.CLAIMED || billingActivty.activityStatus == domains.LifeCycleActivityStatus.UNCLAIMED) ? 1 : 0;
                        }
                        break;
                    }
                }
                return acc;
            }, {})
        }

        $onInit(): void {
            this.user = this.ids.getUser();

            this.isAdvisorUser = (
                this.user.role === "ADVISORY"
                || this.user.role === "ADVISORY_LEAD"
                || this.user.role === "ADVISORY_ADMIN"
            );

            this.isServicerUser = (
                this.user.role === "SERVICER_OPERATIONS"
                || this.user.role === "SERVICER_LEAD"
                || this.user.role === "SERVICER_ADMIN"
            );

            this.gs.getLOVs()
                .then(lovs => this.activityTypes = lovs.filter(f => f.lovType === domains.LovType.ACC_ACTIVITY));
        }

        $onChanges(evt) {
            this.updateActivitiesCaptions();
        }

    }

    class ApplicationTracker implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                showProposedAmount: "<",
                apptrackerdata: "<",
                onAccountArchived: "&",
            };
            this.controller = ApplicationTrackerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/application-tracker.html';
        }
    }
    angular.module(Constants.APP).component("applicationTracker", new ApplicationTracker());
}
